var I=(E=>(E.BOLD="BOLD",E.ITALIC="ITALIC",E.UNDERLINE="UNDERLINE",E))(I||{}),e=(E=>(E.ORDERED_LIST_ITEM="ordered-list-item",E.UNORDERED_LIST_ITEM="unordered-list-item",E))(e||{});export{e as BlockStyleEnum,I as InlineStyleEnum};
